module.exports = __webpack_public_path__ + "img/放款失败后.6b3ecb1e.png";